import { lazy } from "react";

const CreateSongPage = lazy(() => import("./create"));
const SongListPage = lazy(() => import("./main"));
const UpdateSongPage = lazy(() => import("./update"));
const SynchronizedPage = lazy(() => import("./synchronized"));

export { CreateSongPage, SongListPage, UpdateSongPage, SynchronizedPage };
